import { Link } from 'react-router-dom';
import type { Location } from '@/mocks/locations';

interface LocationCardProps {
  location: Location;
}

const cityImages: Record<string, string> = {
  middlesbrough: 'https://public.readdy.ai/ai/img_res/ed9bd61e4a4217eb32343c98741fcc17.jpg',
  durham: 'https://readdy.ai/api/search-image?query=Durham%20Cathedral%20and%20city%20England%20historic%20architecture%2C%20River%20Wear%2C%20British%20heritage%20city%20photography%2C%20overcast%20sky%2C%20photorealistic&width=600&height=380&seq=loc002&orientation=landscape',
  hartlepool: 'https://readdy.ai/api/search-image?query=Hartlepool%20marina%20waterfront%20England%20coastal%20town%2C%20boats%2C%20British%20seaside%20town%20photography%2C%20overcast%20sky%2C%20photorealistic&width=600&height=380&seq=loc003&orientation=landscape',
  hull: 'https://readdy.ai/api/search-image?query=Hull%20city%20centre%20England%20urban%20street%2C%20The%20Deep%20aquarium%2C%20British%20city%20photography%2C%20overcast%20sky%2C%20photorealistic&width=600&height=380&seq=loc004&orientation=landscape',
  sheffield: 'https://readdy.ai/api/search-image?query=Sheffield%20city%20centre%20England%20urban%20landscape%2C%20modern%20buildings%2C%20British%20city%20photography%2C%20overcast%20sky%2C%20clean%20streets%2C%20photorealistic&width=600&height=380&seq=loc005&orientation=landscape',
};

export default function LocationCard({ location }: LocationCardProps) {
  return (
    <div className="bg-white rounded-xl overflow-hidden border border-stone-100 hover:border-[#1B4332]/30 transition-all duration-300 group">
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={cityImages[location.id] ?? cityImages.middlesbrough}
          alt={`Mobile tyre fitting in ${location.city}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
        <span className="absolute bottom-3 left-4 text-white text-xs font-semibold bg-[#1B4332]/80 px-2.5 py-1 rounded-full">
          {location.region}
        </span>
      </div>
      <div className="p-5">
        <h3 className="text-lg font-bold text-stone-900 mb-1">{location.city}</h3>
        <p className="text-stone-500 text-sm mb-4">
          {location.address}, {location.city}, {location.postcode}
        </p>
        <div className="flex flex-col gap-2 mb-5">
          <a
            href={`tel:${location.phone}`}
            className="flex items-center gap-2 text-stone-600 hover:text-[#1B4332] text-sm transition-colors cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center text-[#1B4332]">
              <i className="ri-phone-line" />
            </span>
            {location.phoneFormatted}
          </a>
          <a
            href={location.googleMapsUrl}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center gap-2 text-stone-600 hover:text-[#1B4332] text-sm transition-colors cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center text-[#1B4332]">
              <i className="ri-map-pin-line" />
            </span>
            View on Google Maps
          </a>
        </div>
        <Link
          to={`/locations/${location.slug}`}
          className="block w-full text-center bg-[#1B4332] hover:bg-[#145228] text-white text-sm font-semibold py-2.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
        >
          View Location
        </Link>
      </div>
    </div>
  );
}
